import { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Real-time listener for the "registrations" subcollection.
 * Returns all registrations sorted by newest first.
 */
export function useRegistrations(formId) {
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!formId) return;

        const q = query(
            collection(db, "forms", formId, "registrations"),
            orderBy("createdAt", "desc")
        );

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => {
                const data = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setRegistrations(data);
                setLoading(false);
            },
            (err) => {
                console.error("Error listening to registrations:", err);
                setError(err.message);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [formId]);

    return { registrations, loading, error };
}
